const servicesEn = [
  {
    title: "Trax",
    tagline: "Unified Observability & Active Infrastructure Control",
    description: "Lightweight, high-performance, self-hostable platform built with Rust combining full-stack observability (error tracking, distributed tracing, session replays, profiling, uptime) and active infrastructure control (server monitoring, remote terminal management) with automated remediation.",
    features: [
      "Full-Stack Observability: Distributed tracing, error tracking, profiling & uptime",
      "Active Fleet Control: Real-time server telemetry & remote terminal management",
      "Native Rust Core: Built with Actix-web, Tokio, WebSockets, SQLx & AES-GCM encryption",
      "Zero-Overhead & Self-Hostable: Single container or bare-metal deployment"
    ],
    link: "https://github.com/samirdjelal/trax",
    tags: ["Rust", "Actix-web", "Tokio", "WebSockets", "Observability", "DevOps"],
    category: "Observability & Infrastructure",
    isFlagship: true
  },
  {
    title: "Hydra-gate",
    tagline: "SOCKS5 Proxy Aggregator & Dynamic Load Balancer",
    description: "A lightweight SOCKS5 proxy aggregator and load balancer built with Tauri & Rust. Rotate traffic through multiple upstream SOCKS5/HTTP proxies with automatic health checks.",
    link: "https://github.com/samirdjelal/hydra-gate",
    tags: ["Rust", "Tauri", "Proxy", "Load Balancer", "Networking"],
    category: "Networking & Security"
  },
  {
    title: "Load-nexus",
    tagline: "High-Performance Multi-Threaded API Load Testing",
    description: "High-performance API load testing tool built with Rust and Tauri. Real-time metrics, P99 latencies, and a sleek, multi-threaded engine for modern developers.",
    link: "https://github.com/samirdjelal/load-nexus",
    tags: ["Rust", "Tauri", "Load Testing", "Benchmarking"],
    category: "Developer Tooling"
  },
  {
    title: "TxChk",
    tagline: "Financial Card BIN Intelligence & Validation",
    description: "Check credit card BIN numbers and get detailed information about the card issuer, card scheme, tier, and originating country.",
    link: "https://txchk.samirdjelal.com/",
    tags: ["Fintech", "BIN Checker", "Security", "Validation"],
    category: "Fintech & Security"
  },
  {
    title: "Mail-dev",
    tagline: "Local SMTP Testing Server with Web Dashboard",
    description: "Cross-platform, local SMTP server for email testing and debugging without risking external delivery.",
    link: "https://github.com/samirdjelal/mail-dev",
    tags: ["SMTP", "Testing", "Email", "Cross-Platform"],
    category: "Developer Tooling"
  },
  {
    title: "Captcha-rs",
    tagline: "Zero-Dependency Verification Image Generator in Rust",
    description: "Generate high-entropy verification images dynamically with custom distortion and noise filters in pure Rust.",
    link: "https://github.com/samirdjelal/captcha-rs",
    tags: ["Rust", "Crate", "Security", "Computer Vision"],
    category: "Networking & Security"
  },
  {
    title: "Bidirectional",
    tagline: "BiDi Arabic Unicode Text Processing Utility",
    description: "Enable RTL Arabic text rendering on legacy applications and software without native bidirectional support.",
    link: "https://github.com/samirdjelal/bidirectional",
    tags: ["Arabic", "Unicode", "BiDi", "Text Processing"],
    category: "Developer Tooling"
  },
  {
    title: "DecisionRules",
    tagline: "Cloud Decision Engine & Rule Management",
    description: "Cloud-based decision engine and business rules management system for complex workflow evaluations.",
    link: "https://decisionrule.com/",
    tags: ["Cloud", "Rule Engine", "SaaS", "Automation"],
    category: "Developer Tooling"
  }
];

export default servicesEn;
